<template>
    <div>
        <div v-if='hasNamedHuman || searchingName' class='search-area'>
            <div class='search-control' :class='{ "is-focused": searchFocused }'>
                <span class='search-icon'><i class='fas fa-search'></i></span>
                <input
                    class='search-input'
                    type='text'
                    v-model='searchName'
                    placeholder='生徒名で検索'
                    @keydown.enter='onSearchEnter'
                    @focus='searchFocused = true'
                    @blur='searchFocused = false'
                >
                <button v-if='searchName' class='clear-btn' @click='searchName = ""' aria-label='clear'>
                    <i class='fas fa-times-circle'></i>
                </button>
                <button class='search-submit' @click='searchByName' :disabled='searching'>
                    <span v-if='searching'>検索中…</span>
                    <span v-else>検索</span>
                </button>
            </div>
            <div v-if='searchingName || searchingFace' class='filter-row'>
                <span v-if='searchingName' class='filter-chip filter-chip-name'>
                    <i class='fas fa-user-tag chip-icon'></i>
                    <span class='chip-label'>名前: {{ activeSearchName }}</span>
                    <span class='chip-count'>{{ searchResultPhotos.length }}件</span>
                    <button class='chip-close' @click='endSearchName' aria-label='close'>
                        <i class='fas fa-times'></i>
                    </button>
                </span>
                <span v-if='searchingFace' class='filter-chip filter-chip-face'>
                    <i class='fas fa-camera chip-icon'></i>
                    <span class='chip-label'>顔認証検索中</span>
                    <span class='chip-count'>{{ searchResultPhotos.length }}件</span>
                    <button class='chip-close' @click='endSearchFace' aria-label='close'>
                        <i class='fas fa-times'></i>
                    </button>
                </span>
            </div>
        </div>
        <div v-if='loading' class='loading-area'>
            <p class='loading-text'>写真を読み込み中...</p>
        </div>
        <div v-else-if='displayPhotos && displayPhotos.length' class='photos'>
            <div v-for='photo in displayPhotos' :key='photo.id' class='photo'>
                <div class='photo-image-wrap'>
                    <img v-if='photo.reduction_s3_key' :src='`${photoBaseUrl}/${photo.reduction_s3_key}`' @click='detail(photo.id)' loading='lazy' decoding='async'>
                    <img v-else :src='`${photoBaseUrl}/${photo.s3_key}`' @click='detail(photo.id)' loading='lazy' decoding='async'>
                    <p class='photo-name'>{{ photo.name }}</p>
                </div>
                <div class='image-bottom'>
                    <div class='cart-btn' @click='cartIn(photo.id, photo.size, photo.length)' :class='{ "cart-btn-active": cartMap[photo.id] }'>
                        <i class="fas fa-shopping-cart"></i>
                    </div>
                    <select class='select-size' v-model='photo.size' @change='changePhoto(photo.id, photo.size, photo.length)'>
                        <option v-for='(size, i) in viewSizes' :key='i' :value='size.name' class='size'>
                            {{ size.name }}
                        </option>
                    </select>
                    <select class='select-length' v-model='photo.length' @change='changePhoto(photo.id, photo.size, photo.length)'>
                        <option v-for='n in 99' :key='n' :value='n' class='length'>
                            {{ n }}
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <div v-else class='empty-area'>
            <p v-if='searchingName'>「{{ activeSearchName }}」に該当する写真はありませんでした</p>
            <p v-else-if='searchingFace'>該当する写真がありませんでした</p>
            <p v-else>この行事にはまだ写真がありません</p>
        </div>
        <div v-if='loadingMore && !searchingFace' class='loading-area'>
            <p class='loading-text'>写真を追加で読み込み中...</p>
        </div>
        <div class="modal detail-modal is-clipped" :class=' { "is-active": modalActive }'>
            <div class="modal-background" @click='modalClose'></div>
            <div class="modal-card">
                <div class='image-wrapper' @mousemove="showZoom($event)" @mouseleave="hideZoom" @touchstart.prevent="showZoom($event)" @touchmove.prevent="showZoom($event)" @touchend="hideZoom">
                    <div v-for='(faceFrame, i) in faceFrames' :key='i' class='faceFrame' @click='searchFace(faceFrame.faceId)' @touchstart='searchFace(faceFrame.faceId)' v-bind:style='{
                        "top": faceFrame.top * 100 + "%",
                        "left": faceFrame.left * 100 + "%",
                        "height": faceFrame.height * 80 + "%",
                        "width": faceFrame.width * 100 + "%"
                        }'></div>
                    <img v-if='detailPhoto.reduction_s3_key' class='view-img' :src='`${photoBaseUrl}/${detailPhoto.reduction_s3_key}`' alt="">
                    <img v-else class='view-img' :src='`${photoBaseUrl}/${detailPhoto.s3_key}`' alt="">
                    <div class="zoom-img" ref="zoom">
                        <div v-if='!hiResLoaded' class="zoom-loading">読込中...</div>
                    </div>
                </div>
                <button class="modal-close-btn" aria-label="close" @click='modalClose'>
                    <i class="fas fa-times"></i>
                </button>
                <footer class="modal-card-foot">
                    <div class="modal-cart-btn" @click='cartIn("detail")' :class='{ "modal-cart-btn-active": cartMap[detailId] }'>
                        <i class="fas fa-shopping-cart"></i>
                    </div>
                    <button class="modal-btn modal-btn-nav" @click='backPhoto'>
                        <i class="fas fa-chevron-left"></i> 戻る
                    </button>
                    <button class="modal-btn modal-btn-nav" @click='nextPhoto'>
                        次へ <i class="fas fa-chevron-right"></i>
                    </button>
                    <button class="modal-btn modal-btn-face" @click='getFaceFrames'>
                        <i class="fas fa-search"></i> 顔認証
                    </button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>

// import EXIF from 'exif-js';

export default {
    name: 'PhotoList',
    props: ['photos', 'cartMap', 'sizes', 'defaultSize', 'loading', 'hasMore', 'loadingMore', 'hasNamedHuman'],
    components: {
    },
    data () {
        return {
            photoBaseUrl: process.env.PHOTO_BASE_URL,
            detailId: null,
            detailPhoto: {},
            modalActive: false,
            faceFrames: [],
            displayPhotoIdMap: {},
            searchingFace: false,
            searchingName: false,
            searching: false,
            searchName: '',
            activeSearchName: '',
            searchFocused: false,
            hiResLoaded: false,
            hiResCache: {},
            searchResultPhotos: [],
            scrollHandler: null
        }
    },
    computed: {
        viewSizes () {
            const self = this
            return self.sizes.filter((size) => {
                return size.use
            })
        },
        displayPhotos () {
            if (this.searchingFace || this.searchingName) {
                return this.searchResultPhotos
            }
            return this.photos
        }
    },
    mounted () {
        this.scrollHandler = () => {
            if (this.loading || this.loadingMore || this.searchingFace || this.searchingName || !this.hasMore) return
            const bottomOfWindow = window.scrollY + window.innerHeight >= document.documentElement.offsetHeight - 400
            if (bottomOfWindow) {
                this.$emit('load-more')
            }
        }
        window.addEventListener('scroll', this.scrollHandler, { passive: true })
        this.scrollHandler()
        window.addEventListener('popstate', this.handlePopState)

        const viewImg = document.getElementsByClassName('view-img')[0]
        if (viewImg) {
            viewImg.addEventListener('contextmenu', (e) => {
                e.preventDefault()
            })
        }
    },
    beforeDestroy () {
        if (this.scrollHandler) {
            window.removeEventListener('scroll', this.scrollHandler)
        }
        window.removeEventListener('popstate', this.handlePopState)
    },
    methods: {
        cartIn (id, size, length) {
            if (id === 'detail') {
                this.$root.$emit('cartIn', { id: this.detailId, size: this.detailPhoto.size, length: this.detailPhoto.length })
            } else {
                this.$root.$emit('cartIn', { id: id, size: size, length: length })
            }
        },
        detail (id) {
            this.detailId = id
            this.displayPhotos.forEach((photo) => {
                if (photo.id === id) {
                    this.detailPhoto = photo
                }
            })

            this.faceFrames = []
            this.modalActive = true
            this.preloadHiRes(this.detailPhoto)
            window.history.pushState({ modalOpen: true }, '')
        },
        preloadHiRes (photo) {
            if (!photo || !photo.s3_key) return
            const url = `${this.photoBaseUrl}/${photo.s3_key}`
            if (this.hiResCache[url]) {
                this.hiResLoaded = true
                return
            }
            this.hiResLoaded = false
            const img = new Image()
            img.onload = () => {
                this.hiResCache[url] = true
                if (this.detailPhoto === photo) {
                    this.hiResLoaded = true
                }
            }
            img.src = url
        },
        handlePopState () {
            if (this.modalActive) {
                this.modalActive = false
            }
        },
        getFaceFrames () {
            const self = this
            self.faceFrames = []
            self.axios.get(`${process.env.API_URL}/photobuy/faceFrames?photoId=${self.detailId}`).then((res) => {
                const faceFrames = res.data.faceFrames
                self.faceFrames = faceFrames
                this.$root.$emit('notification', 'is-primary', '検索対象の顔を選択してください')
            })
        },
        searchFace (faceId) {
            const self = this
            self.displayPhotoIdMap = {}
            self.endSearchName()
            self.axios.post(`${process.env.API_URL}/photobuy/searchFace`, {
                faceId
            }).then((res) => {
                const displayPhotoIdMap = res.data.photoIdMap
                self.displayPhotoIdMap = displayPhotoIdMap
                self.searchResultPhotos = res.data.photos.map((photo) => {
                    const cartPhoto = self.cartMap[photo.id]
                    return {
                        ...photo,
                        size: cartPhoto ? cartPhoto.size : self.defaultSize,
                        length: cartPhoto ? cartPhoto.length : 1
                    }
                })
                self.modalActive = false
                self.searchingFace = true
            })
        },
        endSearchFace () {
            this.displayPhotoIdMap = {}
            this.searchResultPhotos = []
            this.searchingFace = false
        },
        onSearchEnter (e) {
            if (e.isComposing || e.keyCode === 229) return
            this.searchByName()
        },
        searchByName () {
            const self = this
            if (self.searching) return
            const name = (self.searchName || '').trim()
            if (!name) {
                self.$root.$emit('notification', 'is-danger', '名前を入力してください')
                return
            }
            const eventId = self.$route.params.id
            self.searching = true
            self.axios.post(`${process.env.API_URL}/photobuy/searchByName`, {
                eventId,
                name
            }).then((res) => {
                if (!res.data || res.data.message !== 'OK') {
                    self.$root.$emit('notification', 'is-danger', '検索に失敗しました')
                    return
                }
                const photos = (res.data.photos || []).map((photo) => {
                    const cartPhoto = self.cartMap[photo.id]
                    return {
                        ...photo,
                        size: cartPhoto ? cartPhoto.size : self.defaultSize,
                        length: cartPhoto ? cartPhoto.length : 1
                    }
                })
                self.searchingFace = false
                self.displayPhotoIdMap = res.data.photoIdMap || {}
                self.searchResultPhotos = photos
                self.activeSearchName = name
                self.searchingName = true
                if (!photos.length) {
                    self.$root.$emit('notification', 'is-primary', '該当する写真がありませんでした')
                }
            }).catch(() => {
                self.$root.$emit('notification', 'is-danger', '検索に失敗しました')
            }).finally(() => {
                self.searching = false
            })
        },
        endSearchName () {
            this.displayPhotoIdMap = {}
            this.searchResultPhotos = []
            this.searchingName = false
            this.activeSearchName = ''
        },
        changePhoto (id, size, length) {
            this.$emit('change-photo', { id: id, size: size, length: length })
            this.$root.$emit('changePhoto', { id: id, size: size, length: length })
        },
        modalClose () {
            this.modalActive = false
            window.history.back()
        },
        nextPhoto () {
            for (let i = 0; i < this.displayPhotos.length; i++) {
                if (this.displayPhotos[i].id === this.detailId) {
                    if (++i === this.displayPhotos.length) {
                        this.$root.$emit('notification', 'is-primary', 'これが最後の写真です')
                    } else {
                        this.detail(this.displayPhotos[i].id)
                    }
                }
            }
        },
        backPhoto () {
            for (let i = this.displayPhotos.length - 1; i >= 0; i--) {
                if (this.displayPhotos[i].id === this.detailId) {
                    if (--i < 0) {
                        this.$root.$emit('notification', 'is-primary', 'これが最初の写真です')
                    } else {
                        this.detail(this.displayPhotos[i].id)
                    }
                }
            }
        },
        showZoom (event) {
            // image-wrapper 内の実際に表示されている img を基準にする
            const wrapper = this.$refs.zoom.parentElement
            const img = wrapper.querySelector('.view-img')
            if (!img) return

            const rect = img.getBoundingClientRect()

            const touch = event.touches ? event.touches[0] : null
            const clientX = touch ? touch.clientX : event.clientX
            const clientY = touch ? touch.clientY : event.clientY

            // 画像内の相対座標を計算
            const offsetX = clientX - rect.left
            const offsetY = clientY - rect.top

            // 画像の範囲外なら表示しない
            if (offsetX < 0 || offsetY < 0 || offsetX > rect.width || offsetY > rect.height) {
                this.$refs.zoom.style.display = 'none'
                return
            }

            const xPercent = offsetX / rect.width
            const yPercent = offsetY / rect.height

            const zoomSize = 200
            const bgWidth = rect.width * 2
            const bgHeight = rect.height * 2
            const bgPosX = -xPercent * bgWidth + zoomSize / 2
            const bgPosY = -yPercent * bgHeight + zoomSize / 2

            // 高解像度が読み込み済みならs3_key、未完了ならreduction版をフォールバック
            const zoomSrc = this.hiResLoaded
                ? `${this.photoBaseUrl}/${this.detailPhoto.s3_key}`
                : `${this.photoBaseUrl}/${this.detailPhoto.reduction_s3_key || this.detailPhoto.s3_key}`
            this.$refs.zoom.style.backgroundImage = `url(${zoomSrc})`
            this.$refs.zoom.style.backgroundSize = bgWidth + 'px ' + bgHeight + 'px'
            this.$refs.zoom.style.backgroundPosition = bgPosX + 'px ' + bgPosY + 'px'

            // スマホではタッチ位置の上に表示、PCでは右下に表示
            const isMobile = window.innerWidth <= 768
            let zoomLeft, zoomTop

            if (isMobile) {
                zoomLeft = offsetX - zoomSize / 2
                zoomTop = offsetY - zoomSize - 20
                if (zoomTop < 0) {
                    zoomTop = offsetY + 20
                }
            } else {
                zoomLeft = offsetX + 20
                zoomTop = offsetY + 20
            }

            // 左右のはみ出し補正
            if (zoomLeft + zoomSize > rect.width) {
                zoomLeft = rect.width - zoomSize
            }
            if (zoomLeft < 0) {
                zoomLeft = 0
            }

            this.$refs.zoom.style.left = zoomLeft + 'px'
            this.$refs.zoom.style.top = zoomTop + 'px'

            this.$refs.zoom.style.display = 'block'
        },
        hideZoom () {
            this.$refs.zoom.style.display = 'none'
        }
    }
}
</script>

<style scoped>

.search-area {
    margin: 20px 0 0;
}

.search-control {
    display: flex;
    align-items: stretch;
    width: 100%;
    max-width: 520px;
    height: 42px;
    background: #fff;
    border: 1px solid #dcdfe3;
    border-radius: 8px;
    overflow: hidden;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.search-control.is-focused {
    border-color: #5a67d8;
    box-shadow: 0 0 0 3px rgba(90, 103, 216, 0.15);
}

.search-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 4px 0 16px;
    color: #8a93a0;
    font-size: 14px;
}

.search-input {
    flex: 1;
    min-width: 0;
    height: 100%;
    border: none;
    outline: none;
    background: transparent;
    padding: 0 12px;
    font-size: 14px;
    line-height: 1;
    color: #222;
}

.search-input::placeholder {
    color: #a4abb6;
}

.clear-btn {
    border: none;
    background: transparent;
    color: #a4abb6;
    cursor: pointer;
    padding: 0 6px;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.15s ease;
}

.clear-btn:hover {
    color: #6a7180;
}

.search-submit {
    border: none;
    background: linear-gradient(135deg, #5a67d8, #4c51bf);
    color: #fff;
    font-weight: 600;
    font-size: 14px;
    padding: 0 22px;
    cursor: pointer;
    transition: filter 0.15s ease, transform 0.05s ease;
}

.search-submit:hover {
    filter: brightness(1.06);
}

.search-submit:active {
    transform: translateY(1px);
}

.search-submit:disabled {
    cursor: progress;
    opacity: 0.7;
    filter: none;
}

.filter-row {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 10px;
}

.filter-chip {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 6px 8px 6px 12px;
    border-radius: 999px;
    font-size: 13px;
    line-height: 1;
    background: #eef1ff;
    color: #3b3f8f;
    border: 1px solid #d4daff;
}

.filter-chip-face {
    background: #fff0f3;
    color: #b8336a;
    border-color: #ffd5e0;
}

.chip-icon {
    font-size: 12px;
    opacity: 0.85;
}

.chip-label {
    max-width: 220px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 600;
}

.chip-count {
    font-size: 11px;
    padding: 2px 8px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.65);
    color: inherit;
    font-weight: 600;
}

.chip-close {
    border: none;
    background: transparent;
    color: inherit;
    opacity: 0.65;
    cursor: pointer;
    padding: 4px 6px;
    border-radius: 999px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity 0.15s ease, background 0.15s ease;
}

.chip-close:hover {
    opacity: 1;
    background: rgba(0, 0, 0, 0.06);
}

@media (max-width: 600px) {
    .search-area {
        margin: 12px 0 0;
    }

    .search-control {
        max-width: 100%;
        height: 38px;
    }

    .search-icon {
        padding-left: 12px;
    }

    .search-input {
        font-size: 13px;
        padding: 0 10px;
    }

    .search-submit {
        padding: 0 16px;
        font-size: 13px;
    }

    .chip-label {
        max-width: 150px;
    }
}

.loading-area {
    margin-top: 60px;
    text-align: center;
}

.loading-text {
    font-size: 16px;
    color: #666;
}

.empty-area {
    margin-top: 60px;
    text-align: center;
    color: #888;
}

.photos {
    margin-top: 24px;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    grid-auto-flow: row;
    gap: 4px;
}

.photo {
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 3px;
    background: #fff;
    overflow: hidden;
    width: 100%;
    display: block;
    align-self: start;
}

.photo-image-wrap {
    position: relative;
}

.photo-image-wrap > img {
    cursor: pointer;
    width: 100%;
    height: auto;
    display: block;
}

.photo-name {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 0;
    padding: 6px 8px;
    font-size: 12px;
    line-height: 1.4;
    color: #fff;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.72), rgba(0, 0, 0, 0.1));
    word-break: break-all;
    pointer-events: none;
}

.image-bottom {
    display: flex;
    height: 40px;
    align-items: center;
    padding: 0 4px;
    gap: 4px;
}

.cart-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 6px;
    background: #e8e8e8;
    color: #555;
    cursor: pointer;
    font-size: 14px;
    flex-shrink: 0;
    transition: background 0.2s, color 0.2s;
}

.cart-btn-active {
    background: #3cb371;
    color: #fff;
}

.view-img {
    width: 100%;
    display: block;
}

.select-size {
    flex: 1;
    min-width: 0;
    height: 30px;
    font-size: 14px;
    margin-top: 0;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    padding: 0 6px;
    border: 1px solid #ccc;
    border-radius: 3px;
    background: #fff;
}

.select-length {
    width: 50px;
    height: 30px;
    font-size: 14px;
    margin-top: 0;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    padding: 0 6px;
    border: 1px solid #ccc;
    border-radius: 3px;
    background: #fff;
}

.detail-modal {
    z-index: 200;
}

.modal-card {
    background-color: rgb(220, 220, 220);
    border-radius: 6px;
    overflow: scroll;
    max-height: 100vh;
    max-width: 95vw;
    position: relative;
}

.faceFrame {
    position: absolute;
    border: 3px solid red;
    cursor: pointer;
}

.image-wrapper {
    position: relative;
    display: block;
    width: 100%;
}

.image-wrapper > img {
    width: 100%;
    max-height: calc(100vh - 80px);
    object-fit: contain;
    display: block;
    touch-action: none;
}

.modal-close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 10;
    width: 40px;
    height: 40px;
    border: none;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s;
}

.modal-close-btn:hover {
    background: rgba(0, 0, 0, 0.7);
}

.modal-card-foot {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 12px 16px;
    background: rgba(0, 0, 0, 0.6);
    border-top: none;
}

.modal-cart-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.15);
    color: #fff;
    cursor: pointer;
    font-size: 16px;
    transition: background 0.2s;
}

.modal-cart-btn:hover {
    background: rgba(255, 255, 255, 0.3);
}

.modal-cart-btn-active {
    background: #3cb371 !important;
    color: #fff !important;
}

.modal-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 8px 18px;
    border: none;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.2s, transform 0.1s;
}

.modal-btn:active {
    transform: scale(0.96);
}

.modal-btn-nav {
    background: rgba(255, 255, 255, 0.9);
    color: #333;
}

.modal-btn-nav:hover {
    background: #fff;
}

.modal-btn-face {
    background: #5a67d8;
    color: #fff;
}

.modal-btn-face:hover {
    background: #4c51bf;
}

.zoom-img {
    z-index: 2000000000000000;
    position: absolute;
    display: none;
    border: 1px solid #000;
    width: 200px;
    height: 200px;
    background-repeat: no-repeat;
    pointer-events: none;
}

.zoom-loading {
    position: absolute;
    bottom: 4px;
    left: 0;
    right: 0;
    text-align: center;
    font-size: 10px;
    color: #fff;
    background: rgba(0, 0, 0, 0.5);
    padding: 2px 0;
    border-radius: 0 0 3px 3px;
    pointer-events: none;
}

@media screen and (max-width: 1100px) {
    .photos {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 600px) {
    .photos {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 2px;
        margin-top: 16px;
    }

    .photo {
        border-radius: 2px;
    }

    .image-bottom {
        height: 32px;
        padding: 0 2px;
        gap: 2px;
    }

    .photo-name {
        padding: 4px 6px;
        font-size: 11px;
    }

    .cart-btn {
        width: 28px;
        height: 28px;
        font-size: 12px;
    }

    .select-size {
        height: 26px;
        font-size: 12px;
        padding: 0 4px;
    }

    .select-length {
        width: 36px;
        height: 26px;
        font-size: 12px;
        padding: 0 4px;
    }

    .modal-card-foot {
        padding: 10px;
        gap: 8px;
    }

    .modal-btn {
        padding: 10px 16px;
        font-size: 14px;
        gap: 5px;
    }

    .modal-cart-btn {
        width: 42px;
        height: 42px;
        font-size: 18px;
    }

    .modal-close-btn {
        width: 44px;
        height: 44px;
        font-size: 22px;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/photobuy/pages/PhotoList.vue